<button mat-stroked-button
  class="jafar-dismiss-button"
  (click)="onClick()"
  [disabled]="disabled">
  <ng-content></ng-content>
</button>
